import React from 'react';

import { useReactNodeView } from '@lyearn/lygo-core';

import FileComponentEditable from './FileEditable';
import FileComponentReadonly from './FileReadOnly';

const FileNodeView: React.FC = () => {
  const { node, view, updateAttrs } = useReactNodeView();

  if (!view?.editable) {
    return <FileComponentReadonly {...node?.attrs} />;
  }

  return <FileComponentEditable {...node?.attrs} />;
};

export default FileNodeView;
